module.exports = __webpack_public_path__ + "static/tonys-02-5f71938b1af9c123d25c2694332ecf5f.png";